import { render } from "./EntitlementDiscount.vue?vue&type=template&id=6c243402"
import script from "./EntitlementDiscount.vue?vue&type=script&lang=js"
export * from "./EntitlementDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__